import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { init } from '../../auth/handleTokens';
import { constants } from '../../constants';
import NotificationContext from '../toasts/NotificationContext';

const ListAuthMessage = (props) => {
    const toggle = props.toggleSidebar ? '240px' : '10px';
    const [messages, setMessages] = useState([]);
    const [changeMessages, setChangeMessages] = useState(false);
    const {showNotification} = useContext(NotificationContext);

    const getMessages =  async() => {
        try {
          console.log('getMessage...')
          const result = await init();
          console.log( result +' continuamos getMessagePending...')
          if(!result) return window.location.href = '/login';
          const token = window.localStorage.getItem('at');
          const URL = constants.test_host + '/sms/getall-auth-messages';
          const {data} = await axios.get(URL, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
          setMessages(data.authMessages);
          return
          
         } catch (error) {
            console.log(error)
         }
    }

    const refreshMessage = () => {
      setChangeMessages(!changeMessages);
    }

    const selectionMessage = async(target, action ) => {
        const result = await init();
        console.log( result +' continuamos selectionMessage...')
        if(!result) return window.location.href = '/login';
        const token = window.localStorage.getItem('at');
        switch (action) {
            case 'enabled':
              const URL = constants.test_host + '/sms/disabledmessage/' + target.offsetParent.id;
              await axios.put(URL, {},{headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
              .then(({data}) => {
                setChangeMessages(!changeMessages);
                return showNotification('success', data.message)
              })
            
              break;
            case 'delete':
              const URL2 = constants.test_host + '/sms/delete-auth-message/' + target.offsetParent.id;
              await axios.delete(URL2, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
              .then(({data}) => {
                setChangeMessages(!changeMessages);
                return showNotification('success', data.message)
              })
              .catch((err) => {
                console.log(err)
                return showNotification('failed', err.response.data.message)
              })
                break
        
            default:
                break;
        }

    }
  

    const tableMessages = messages.map((item, index) =>
      <tr key={item._id}>
        <td>{index + 1}</td>
        <td style={{textAlign: 'justify'}}>{item.content}</td>
        <td title='Número de caracteres' style={{textAlign: 'justify'}}>{item.characters}</td>
        <td title='Número de créditos' style={{textAlign: 'justify'}}>{item.credits}</td>
        <td style={{textAlign: 'justify'}}>{item.dateRequest}</td>
        <td style={{textAlign: 'justify'}}>{item.dateAuth}</td>
        <td style={{textAlign: 'justify'}}>{item.adminResponsible.name}</td>
        <td id={item._id} style={{textAlign: 'justify'}}> <a title= {item.enabled ? 'Deshabilitar mensaje': 'Habilitar mensaje'} className='btn-sm btn btn-primary' onClick={(e) => selectionMessage(e.target, 'enabled')}><i className={item.enabled ? "fas fa-comment-slash": "fas fa-comment"}></i></a> <a title='Eliminar mensaje' className='btn-sm btn btn-primary' onClick={(e) => selectionMessage(e.target, 'delete')}><i class="fas fa-times-circle"></i></a></td>
      </tr>
    )
    
    useEffect(()=> {
        getMessages();
    }, [changeMessages])

    return (
      <div className="content-wrapper content" style={{ marginLeft: `${toggle}`, transition: "all 0.5s" }} >
        <h6 style={{textAlign: 'left', paddingLeft:'5px', fontSize:'smaller'}}>Lista de mensajes Aprobados: <button onClick={() => refreshMessage()} title='Refrescar' className='btn btn-sm btn-primary'><i className="fas fa-sync-alt"></i></button> </h6>
        <table className="table table-striped" style={{fontSize:'small', textAlign: 'justify'}}>
          <thead>
            <tr>
              <th>#Id</th>
              <th>Mensaje</th>
              <th title='Número de caracteres'>Caract</th>
              <th title='Número de créditos'>Cred</th>
              <th>F.Solicitud</th>
              <th>F.Aprobado</th>
              <th>By</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {tableMessages}
          </tbody>
        </table>
      </div>
    )
}


export default ListAuthMessage
